// Multilingual menu data for Segreto Ristorante Italiano — Final version
// Languages: pl, en, it, de. Prices in PLN. Order fixed.

// Helper: name, {desc per lang}, price. Optional weight.
const I = (name, dPL, dEN, dIT, dDE, price, weight) => ({
  name,
  desc: { pl: dPL, en: dEN, it: dIT, de: dDE },
  price,
  weight,
});

export const MENU = [
  // 1. ANTIPASTI
  {
    id: "antipasti",
    name: { pl: "Antipasti", en: "Antipasti", it: "Antipasti", de: "Antipasti" },
    items: [
      I("All’Italiana",
        "prosciutto crudo z soczystymi pomidorami i aromatycznymi oliwkami, rukola, parmigiano reggiano, focaccia",
        "prosciutto crudo with juicy tomatoes and aromatic olives, rocket, parmigiano reggiano, focaccia",
        "prosciutto crudo con pomodori succosi e olive aromatiche, rucola, parmigiano reggiano, focaccia",
        "prosciutto crudo mit saftigen Tomaten und aromatischen Oliven, Rucola, Parmigiano Reggiano, Focaccia",
        "55", "~200 g"),
      I("Carpaccio",
        "delikatne carpaccio z wołowiny z rukolą, płatkami Parmigiano i aromatyczną oliwą",
        "delicate beef carpaccio with rocket, Parmigiano shavings and aromatic olive oil",
        "delicato carpaccio di manzo con rucola, scaglie di Parmigiano e olio d'oliva aromatico",
        "zartes Rinder-Carpaccio mit Rucola, Parmigiano-Spänen und aromatischem Olivenöl",
        "55", "~150 g"),
      I("Gamberetti",
        "krewetki na maśle i winie z nutą czosnku",
        "shrimp in butter and wine with a hint of garlic",
        "gamberetti al burro e vino con una nota d'aglio",
        "Garnelen in Butter und Wein mit einer Note von Knoblauch",
        "51", "~150 g"),
    ],
  },
  // 2. PRIMO PIATTO / ZUPA
  {
    id: "primo-piatto",
    name: { pl: "Primo piatto / Zupa", en: "First course / Soup", it: "Primo piatto / Zuppa", de: "Erster Gang / Suppe" },
    items: [
      I("Crema di Pomodoro",
        "aksamitny krem z pomidorów z delikatną mozzarellą i świeżą bazylią",
        "velvety tomato cream with delicate mozzarella and fresh basil",
        "vellutata di pomodoro con mozzarella delicata e basilico fresco",
        "samtige Tomatencremesuppe mit zarter Mozzarella und frischem Basilikum",
        "29", "~250 g"),
    ],
  },
  // 3. INSALATE
  {
    id: "insalate",
    name: { pl: "Insalate", en: "Salads", it: "Insalate", de: "Salate" },
    items: [
      I("Insalate Segreto",
        "z soczystą pomarańczą, aromatyczną żurawiną, chrupiącymi orzechami i kremową gorgonzolą",
        "with juicy orange, aromatic cranberry, crunchy nuts and creamy gorgonzola",
        "con arancia succosa, mirtillo rosso aromatico, noci croccanti e gorgonzola cremoso",
        "mit saftiger Orange, aromatischer Cranberry, knackigen Nüssen und cremigem Gorgonzola",
        "53", "~350 g"),
      I("Insalate di pollo",
        "grillowana pierś z kurczaka z pomidorkami koktajlowymi, szpinak, rukola, oliwki, orzechy włoskie, dressing",
        "grilled chicken breast with cherry tomatoes, spinach, rocket, olives, walnuts, dressing",
        "petto di pollo grigliato con pomodorini, spinaci, rucola, olive, noci, dressing",
        "gegrillte Hähnchenbrust mit Kirschtomaten, Spinat, Rucola, Oliven, Walnüssen, Dressing",
        "53", "~330 g"),
      I("Burratta al Tonno",
        "kremowa burrata podana z delikatnym tuńczykiem i świeżą sałatką, oliwkami i pomidorkami koktajlowymi",
        "creamy burrata served with delicate tuna, fresh salad, olives and cherry tomatoes",
        "burrata cremosa servita con tonno delicato, insalata fresca, olive e pomodorini",
        "cremige Burrata mit zartem Thunfisch, frischem Salat, Oliven und Kirschtomaten",
        "55", "~400 g"),
    ],
  },
  // 4. DANIE GŁÓWNE
  {
    id: "danie-glowne",
    name: { pl: "Danie główne", en: "Main courses", it: "Piatti principali", de: "Hauptgerichte" },
    items: [
      I("Ossobuco",
        "delikatna gicz cielęca podana z konfiturą z czerwonej cebuli oraz pieczone ziemniaki w towarzystwie warzyw",
        "tender veal shank served with red onion jam and roasted potatoes with vegetables",
        "ossobuco di vitello tenero con confettura di cipolla rossa e patate al forno con verdure",
        "zarter Kalbshaxen mit Rotzwiebel-Konfitüre und Ofenkartoffeln mit Gemüse",
        "98", "~300 g mięso + dodatki 200 g"),
      I("Cotoletta alla Milanese",
        "chrupiący schab panierowany z dodatkiem parmezanu podany z orzeźwiającą ziołową mizerią i puree",
        "crispy breaded pork with parmesan, served with refreshing herb cucumber salad and mashed potatoes",
        "cotoletta di maiale croccante impanata con parmigiano, insalata di cetrioli alle erbe e purè",
        "knuspriges paniertes Schweineschnitzel mit Parmesan, erfrischendem Kräuter-Gurkensalat und Kartoffelpüree",
        "65", "~550 g"),
      I("Petto di pollo alla griglia",
        "pierś z kurczaka serwowana z aksamitnym puree, szpinakiem w aromatycznym pesto oraz warzywami",
        "chicken breast served with velvety mashed potatoes, spinach in aromatic pesto and vegetables",
        "petto di pollo con purè vellutato, spinaci in pesto aromatico e verdure",
        "Hähnchenbrust mit samtigem Kartoffelpüree, Spinat in aromatischem Pesto und Gemüse",
        "62", "~450 g"),
    ],
  },
  // 5. PASTA
  {
    id: "pasta",
    name: { pl: "Pasta", en: "Pasta", it: "Pasta", de: "Pasta" },
    items: [
      I("Carbonara",
        "spaghetti z chrupiącym guanciale, aromatycznym czosnkiem i mieszanką serów Pecorino oraz Parmigiano Reggiano",
        "spaghetti with crispy guanciale, aromatic garlic and a blend of Pecorino and Parmigiano Reggiano",
        "spaghetti con guanciale croccante, aglio aromatico e mix di Pecorino e Parmigiano Reggiano",
        "Spaghetti mit knusprigem Guanciale, aromatischem Knoblauch und einer Mischung aus Pecorino und Parmigiano Reggiano",
        "55", "~350 g"),
      I("Bolognese",
        "spaghetti w aromatycznym sosie pomidorowym z soczystym mięsem, podkręcone nutą wina",
        "spaghetti in aromatic tomato sauce with juicy meat, enhanced with a touch of wine",
        "spaghetti al sugo di pomodoro aromatico con carne succosa, con una nota di vino",
        "Spaghetti in aromatischer Tomatensauce mit saftigem Fleisch, verfeinert mit einem Hauch Wein",
        "55", "~350 g"),
      I("Tagliatelle al ragù di manzo e funghi porcini",
        "tagliatelle podane z soczystą wołowiną i aromatycznymi borowikami",
        "tagliatelle with juicy beef and aromatic porcini mushrooms",
        "tagliatelle con manzo succoso e porcini aromatici",
        "Tagliatelle mit saftigem Rindfleisch und aromatischen Steinpilzen",
        "73", "~400 g"),
      I("Napoli",
        "klasyczne spaghetti z soczystymi pomidorami koktajlowymi, aromatycznymi anchois, czarnymi oliwkami, kaparami i pikantnym peperoncino",
        "classic spaghetti with juicy cherry tomatoes, aromatic anchovies, black olives, capers and spicy peperoncino",
        "spaghetti classici con pomodorini succosi, acciughe aromatiche, olive nere, capperi e peperoncino piccante",
        "klassische Spaghetti mit saftigen Kirschtomaten, aromatischen Sardellen, schwarzen Oliven, Kapern und scharfem Peperoncino",
        "52", "~300 g"),
      I("Spagetti on Gamberetti",
        "makaron z soczystymi krewetkami w aromatycznym sosie z oliwy, czosnku i białego wina, z nutą chili i świeżej pietruszki",
        "pasta with juicy shrimp in aromatic olive oil, garlic and white wine sauce, with a hint of chilli and fresh parsley",
        "pasta con gamberetti succosi in salsa aromatica di olio, aglio e vino bianco, con una nota di peperoncino e prezzemolo fresco",
        "Pasta mit saftigen Garnelen in aromatischer Sauce aus Olivenöl, Knoblauch und Weißwein, mit einer Note von Chili und frischer Petersilie",
        "72", "~350 g"),
      I("Tagliatelle nero di Gamberetti",
        "krewetki w aromatycznym czosnku, kolendrze i pomidorach, z nutą limonki i białego wina",
        "shrimp in aromatic garlic, coriander and tomatoes, with a hint of lime and white wine",
        "gamberetti in aglio aromatico, coriandolo e pomodori, con una nota di lime e vino bianco",
        "Garnelen in aromatischem Knoblauch, Koriander und Tomaten, mit einer Note von Limette und Weißwein",
        "72", "~400 g"),
      I("Spinacci",
        "delikatny makaron w aromatycznym pesto z czosnkiem, świeżym szpinakiem i suszonymi pomidorami, posypany nutą Parmigiano Reggiano",
        "delicate pasta in aromatic pesto with garlic, fresh spinach and sun-dried tomatoes, sprinkled with Parmigiano Reggiano",
        "pasta delicata al pesto aromatico con aglio, spinaci freschi e pomodori secchi, con una nota di Parmigiano Reggiano",
        "zarte Pasta in aromatischem Pesto mit Knoblauch, frischem Spinat und getrockneten Tomaten, mit einer Note von Parmigiano Reggiano",
        "53", "~300 g"),
    ],
  },
  // 6. DESER
  {
    id: "deser",
    name: { pl: "Deser", en: "Dessert", it: "Dolce", de: "Dessert" },
    items: [
      I("Deser",
        "informacja u obsługi", "ask our staff", "chiedi al personale", "beim Personal erfragen",
        "—"),
    ],
  },
  // 7. PIZZA ROMANA (28 items in given order)
  {
    id: "pizza-romana",
    name: { pl: "Pizza Romana", en: "Roman Pizza", it: "Pizza Romana", de: "Römische Pizza" },
    items: [
      I("Pizza Calabrese",     "sos pomidorowy, mozzarella, salami",
        "tomato sauce, mozzarella, salami",
        "salsa di pomodoro, mozzarella, salame",
        "Tomatensauce, Mozzarella, Salami", "51"),
      I("Pizza Cardinale",     "sos pomidorowy, mozzarella, prosciutto cotto",
        "tomato sauce, mozzarella, cooked ham",
        "salsa di pomodoro, mozzarella, prosciutto cotto",
        "Tomatensauce, Mozzarella, gekochter Schinken", "51"),
      I("Pizza Margherita",    "sos pomidorowy, mozzarella, bazylia",
        "tomato sauce, mozzarella, basil",
        "salsa di pomodoro, mozzarella, basilico",
        "Tomatensauce, Mozzarella, Basilikum", "38"),
      I("Pizza ’Nduja",        "sos pomidorowy, mozzarella, ’nduja, mascarpone, miód",
        "tomato sauce, mozzarella, 'nduja, mascarpone, honey",
        "salsa di pomodoro, mozzarella, 'nduja, mascarpone, miele",
        "Tomatensauce, Mozzarella, 'Nduja, Mascarpone, Honig", "56"),
      I("Pizza Diavola",       "sos pomidorowy, mozzarella, salami piccante, oliwki czarne, peperoncino",
        "tomato sauce, mozzarella, spicy salami, black olives, peperoncino",
        "salsa di pomodoro, mozzarella, salame piccante, olive nere, peperoncino",
        "Tomatensauce, Mozzarella, scharfe Salami, schwarze Oliven, Peperoncino", "54"),
      I("Pizza Quatro Formaggi","sos pomidorowy, mozzarella, gorgonzola, feta, parmezan, reggiano",
        "tomato sauce, mozzarella, gorgonzola, feta, parmesan, reggiano",
        "salsa di pomodoro, mozzarella, gorgonzola, feta, parmigiano, reggiano",
        "Tomatensauce, Mozzarella, Gorgonzola, Feta, Parmesan, Reggiano", "56"),
      I("Pizza con Perle e Gorgonzola","sos biały, mozzarella, gruszka, orzechy włoskie, gorgonzola, miód i nuta cytryny",
        "white sauce, mozzarella, pear, walnuts, gorgonzola, honey and a hint of lemon",
        "salsa bianca, mozzarella, pera, noci, gorgonzola, miele e nota di limone",
        "weiße Sauce, Mozzarella, Birne, Walnüsse, Gorgonzola, Honig und Zitronennote", "56"),
      I("Pizza Capricciosa",   "sos pomidorowy, mozzarella, prosciutto cotto, pieczarki, karczochy, oliwki czarne",
        "tomato sauce, mozzarella, cooked ham, mushrooms, artichokes, black olives",
        "salsa di pomodoro, mozzarella, prosciutto cotto, funghi, carciofi, olive nere",
        "Tomatensauce, Mozzarella, gekochter Schinken, Champignons, Artischocken, schwarze Oliven", "55"),
      I("Pizza Monte Cocuzzo", "sos pomidorowy, mozzarella, salsiccia, świeże grzyby, peperoncino, pietruszka",
        "tomato sauce, mozzarella, salsiccia, fresh mushrooms, peperoncino, parsley",
        "salsa di pomodoro, mozzarella, salsiccia, funghi freschi, peperoncino, prezzemolo",
        "Tomatensauce, Mozzarella, Salsiccia, frische Pilze, Peperoncino, Petersilie", "58"),
      I("Pizza Marinara",      "sos pomidorowy, mozzarella, czosnek",
        "tomato sauce, mozzarella, garlic",
        "salsa di pomodoro, mozzarella, aglio",
        "Tomatensauce, Mozzarella, Knoblauch", "41"),
      I("Pizza Biancaneve",    "sos biały, mozzarella, bazylia",
        "white sauce, mozzarella, basil",
        "salsa bianca, mozzarella, basilico",
        "weiße Sauce, Mozzarella, Basilikum", "42"),
      I("Pizza di Gamberetti", "sos pomidorowy, mozzarella, krewetki, pietruszka",
        "tomato sauce, mozzarella, shrimp, parsley",
        "salsa di pomodoro, mozzarella, gamberetti, prezzemolo",
        "Tomatensauce, Mozzarella, Garnelen, Petersilie", "59"),
      I("Pizza Vegetariana",   "sos pomidorowy, mozzarella, bakłażan, cukinia, papryka, peperoni, pesto",
        "tomato sauce, mozzarella, aubergine, courgette, peppers, peperoni, pesto",
        "salsa di pomodoro, mozzarella, melanzane, zucchine, peperoni, peperoncini, pesto",
        "Tomatensauce, Mozzarella, Aubergine, Zucchini, Paprika, Peperoni, Pesto", "52"),
      I("Pizza Con Asparagi",  "sos biały, mozzarella, szparagi, pomidor, pesto",
        "white sauce, mozzarella, asparagus, tomato, pesto",
        "salsa bianca, mozzarella, asparagi, pomodoro, pesto",
        "weiße Sauce, Mozzarella, Spargel, Tomate, Pesto", "55"),
      I("Pizza Con Asparagi Prosciutto","sos biały, mozzarella, szparagi, prosciutto cotto, bazylia, pesto",
        "white sauce, mozzarella, asparagus, cooked ham, basil, pesto",
        "salsa bianca, mozzarella, asparagi, prosciutto cotto, basilico, pesto",
        "weiße Sauce, Mozzarella, Spargel, gekochter Schinken, Basilikum, Pesto", "58"),
      I("Pizza Al Peperoni",   "sos pomidorowy, mozzarella, salami piccante, peperoni",
        "tomato sauce, mozzarella, spicy salami, peperoni",
        "salsa di pomodoro, mozzarella, salame piccante, peperoni",
        "Tomatensauce, Mozzarella, scharfe Salami, Peperoni", "53"),
      I("Pizza Primavera",     "sos pomidorowy, mozzarella, prosciutto crudo, świeże pomidory, parmigiano reggiano, rukola",
        "tomato sauce, mozzarella, prosciutto crudo, fresh tomatoes, parmigiano reggiano, rocket",
        "salsa di pomodoro, mozzarella, prosciutto crudo, pomodori freschi, parmigiano reggiano, rucola",
        "Tomatensauce, Mozzarella, Prosciutto crudo, frische Tomaten, Parmigiano Reggiano, Rucola", "58"),
      I("Pizza Tonno Cipolla", "sos pomidorowy, mozzarella, tuńczyk, cebula",
        "tomato sauce, mozzarella, tuna, onion",
        "salsa di pomodoro, mozzarella, tonno, cipolla",
        "Tomatensauce, Mozzarella, Thunfisch, Zwiebel", "53"),
      I("Pizza con Crudo",     "sos pomidorowy, mozzarella, prosciutto crudo",
        "tomato sauce, mozzarella, prosciutto crudo",
        "salsa di pomodoro, mozzarella, prosciutto crudo",
        "Tomatensauce, Mozzarella, Prosciutto crudo", "53"),
      I("Pizza al Fungi",      "sos pomidorowy, mozzarella, pieczarki",
        "tomato sauce, mozzarella, mushrooms",
        "salsa di pomodoro, mozzarella, funghi",
        "Tomatensauce, Mozzarella, Champignons", "46"),
      I("Pizza Mortadella al Pistacchio","sos biały, mortadella, pistacje, oliwa truflowa",
        "white sauce, mortadella, pistachio, truffle oil",
        "salsa bianca, mortadella, pistacchio, olio al tartufo",
        "weiße Sauce, Mortadella, Pistazien, Trüffelöl", "58"),
      I("Pizza Spianata Piccante","sos pomidorowy, mozzarella, spianata piccante, kapary",
        "tomato sauce, mozzarella, spianata piccante, capers",
        "salsa di pomodoro, mozzarella, spianata piccante, capperi",
        "Tomatensauce, Mozzarella, Spianata piccante, Kapern", "54"),
      I("Pizza Alle Olive",    "sos pomidorowy, mozzarella, zielone oliwki, czarne oliwki",
        "tomato sauce, mozzarella, green olives, black olives",
        "salsa di pomodoro, mozzarella, olive verdi, olive nere",
        "Tomatensauce, Mozzarella, grüne Oliven, schwarze Oliven", "46"),
      I("Calzone",             "sos pomidorowy, mozzarella, prosciutto cotto",
        "tomato sauce, mozzarella, cooked ham",
        "salsa di pomodoro, mozzarella, prosciutto cotto",
        "Tomatensauce, Mozzarella, gekochter Schinken", "54"),
      I("Pizza Completa",      "sos pomidorowy, mozzarella, anchois, kapary",
        "tomato sauce, mozzarella, anchovies, capers",
        "salsa di pomodoro, mozzarella, acciughe, capperi",
        "Tomatensauce, Mozzarella, Sardellen, Kapern", "57"),
      I("Pizza Vulcano",       "sos pomidorowy, mozzarella, ’nduja, salsiccia, spianata piccante, czosnek, cebula",
        "tomato sauce, mozzarella, 'nduja, salsiccia, spianata piccante, garlic, onion",
        "salsa di pomodoro, mozzarella, 'nduja, salsiccia, spianata piccante, aglio, cipolla",
        "Tomatensauce, Mozzarella, 'Nduja, Salsiccia, Spianata piccante, Knoblauch, Zwiebel", "63"),
      I("Pizza SeGreto",       "sos pomidorowy, mozzarella, salami, tuńczyk, salsiccia, prosciutto crudo, rukola",
        "tomato sauce, mozzarella, salami, tuna, salsiccia, prosciutto crudo, rocket",
        "salsa di pomodoro, mozzarella, salame, tonno, salsiccia, prosciutto crudo, rucola",
        "Tomatensauce, Mozzarella, Salami, Thunfisch, Salsiccia, Prosciutto crudo, Rucola", "64"),
      I("Pizza del Mese",      "informacja u obsługi",
        "ask our staff",
        "chiedi al personale",
        "beim Personal erfragen", "58"),
    ],
    footnote: {
      pl: "Alergeny: mąka, mleko",
      en: "Allergens: flour, milk",
      it: "Allergeni: farina, latte",
      de: "Allergene: Mehl, Milch",
    },
  },
  // 8. LEMONIADA DOMOWA (Soft drinks + water + juices)
  {
    id: "lemoniada-domowa",
    name: { pl: "Lemoniada Domowa", en: "Homemade lemonade", it: "Limonata fatta in casa", de: "Hausgemachte Limonade" },
    items: [
      I("Pepsi, Pepsi Zero, Mirinda, 7up, Schweppes", "0,2 l", "0.2 l", "0,2 l", "0,2 l", "14"),
      I("Lemoniada domowa", "0,4 l", "0.4 l", "0,4 l", "0,4 l", "19"),
      I("Sok z wyciskanych pomarańczy",
        "0,3 l",
        "freshly squeezed orange juice 0.3 l",
        "spremuta d'arancia 0,3 l",
        "frisch gepresster Orangensaft 0,3 l",
        "25"),
      I("Sok z wytłaczanych jabłek",
        "0,3 l",
        "pressed apple juice 0.3 l",
        "succo di mele spremute 0,3 l",
        "gepresster Apfelsaft 0,3 l",
        "16"),
      I("Woda g/ng",
        "0,3 l",
        "sparkling / still water 0.3 l",
        "acqua frizzante / naturale 0,3 l",
        "Wasser mit/ohne Kohlensäure 0,3 l",
        "11"),
    ],
  },
  // 9. COFFEE
  {
    id: "coffee",
    name: { pl: "Coffee", en: "Coffee", it: "Caffè", de: "Kaffee" },
    items: [
      I("Bombardino espresso", "", "", "", "", "27"),
      I("Espresso",            "", "", "", "", "11"),
      I("Doppio Espresso",     "", "", "", "", "15"),
      I("Cappuccino",          "", "", "", "", "15"),
      I("Americano",           "", "", "", "", "13"),
      I("Latte",               "", "", "", "", "16"),
      I("Herbata",             "", "tea", "tè", "Tee", "13"),
    ],
  },
  // 10. ALKOHOLE Z BECZKI
  {
    id: "alkohole-z-beczki",
    name: { pl: "Alkohole z beczki", en: "Draft alcohol", it: "Alcolici alla spina", de: "Getränke vom Fass" },
    items: [
      I("Spritz Orange",       "0,35 l", "0.35 l", "0,35 l", "0,35 l", "35"),
      I("Frizzante bianco",    "0,15 l", "0.15 l", "0,15 l", "0,15 l", "19"),
      I("Birra Moretti",       "0,3 / 0,5", "0.3 / 0.5", "0,3 / 0,5", "0,3 / 0,5", "19 / 23"),
      I("Żywiec Białe z nutą", "0,3 / 0,5", "0.3 / 0.5", "0,3 / 0,5", "0,3 / 0,5", "18 / 20"),
    ],
  },
  // 11. DRINK FRIZZANTE
  {
    id: "drink-frizzante",
    name: { pl: "Drink Frizzante", en: "Frizzante drinks", it: "Drink Frizzante", de: "Frizzante-Drinks" },
    items: [
      I("Limoncello e lawenda", "", "", "", "", "35"),
      I("Hugo",                 "", "", "", "", "32"),
      I("Alla Rosa",            "", "", "", "", "32"),
    ],
  },
  // 12. DRINK
  {
    id: "drink",
    name: { pl: "Drink", en: "Cocktails", it: "Cocktail", de: "Cocktails" },
    items: [
      I("Vetz",              "", "", "", "", "45"),
      I("Negroni",           "", "", "", "", "43"),
      I("Pornstar Martini",  "", "", "", "", "44"),
      I("Mojito",            "", "", "", "", "36"),
    ],
  },
  // 13. BIRRA / PIWO BUTELKA
  {
    id: "birra",
    name: { pl: "Birra / Piwo butelka", en: "Beer / bottled beer", it: "Birra / birra in bottiglia", de: "Bier / Flaschenbier" },
    items: [
      I("Birra Artigianale Italiana", "0,33 l", "0.33 l", "0,33 l", "0,33 l", "30"),
      I("Birra Italiana “0”",         "0,33 l · bezalkoholowe", "0.33 l · non-alcoholic", "0,33 l · analcolica", "0,33 l · alkoholfrei", "17"),
    ],
  },
  // 14. VINO
  {
    id: "vino",
    name: { pl: "Vino", en: "Wine", it: "Vino", de: "Wein" },
    items: [
      I("Vino della Casa", "0,15 l", "0.15 l", "0,15 l", "0,15 l", "19"),
    ],
  },
  // 15. APERITIVO / LIGHT VERSION "0"
  {
    id: "aperitivo-0",
    name: {
      pl: "Aperitivo / Light Version “0”",
      en: "Aperitivo / Light Version “0”",
      it: "Aperitivo / Light Version “0”",
      de: "Aperitivo / Light Version „0“",
    },
    items: [
      I("Mojito",     "", "", "", "", "25"),
      I("Aperol",     "", "", "", "", "25"),
      I("Aperitivo",  "", "", "", "", "16"),
    ],
  },
  // 16. ALKOHOL 40 ML
  {
    id: "alkohol-40",
    name: { pl: "Alkohol 40 ml", en: "Alcohol 40 ml", it: "Alcolici 40 ml", de: "Alkohol 40 ml" },
    items: [
      I("Whisky",        "", "", "", "", "20"),
      I("Limoncello",    "", "", "", "", "19"),
      I("Gin",           "", "", "", "", "20"),
      I("Rum",           "40 / 100 ml", "40 / 100 ml", "40 / 100 ml", "40 / 100 ml", "19 / 45"),
      I("Tequila",       "", "", "", "", "25"),
      I("Wódka",         "", "", "", "", "14"),
      I("Jägermeister",  "", "", "", "", "19"),
    ],
  },
];

// Signature order preserved for homepage cards (pizza is now last in food but
// signature card key -> menu id mapping is decorative only)
export const SIGNATURE = ["pizza", "antipasti", "pasta", "main", "dessert", "drinks"];
